
                            const chunks = `/// #replace #define SIXTY_UNIFORMS_AREA
#define SIXTY_UNIFORMS_AREA

uniform sampler2D tPoresNormal;
uniform sampler2D tNoise;
uniform float uDarkMode;

varying vec3 vPosition; 


/// #replace #define SIXTY_NORMALMAP_AREA
#define SIXTY_NORMALMAP_AREA

tbn = getTangentFrame(-vViewPosition, normal, vNormalMapUv);

float noise = smoothstep(0.29, 0.3, texture2D(tNoise, vMapUv).r);
vec2 poresUv = mix(vNormalMapUv * 20., vNormalMapUv * 35. + 0.2, noise);
vec3 nTex2 = texture2D(tPoresNormal, vec2(poresUv.x, 1. * poresUv.y)).rgb * 2. - 1.;

nTex2.xy *= 1.;

normal = normalize(tbn * nTex2);


// diffuseColor.rgb = vec3(vNormalMapUv * 40., 0.);


/// #replace iblIrradiance += getIBLIrradiance(geometryNormal, tEnvMap, uEnvMapIntensity, uEnvMapRotation);
// float envmapIntensity = uEnvMapIntensity * (1. + vViewPosition.y);
// float envmapIntensity = 1. + 0.8 * smoothstep(-.5, -.8, vPosition.y);
iblIrradiance += getIBLIrradiance(geometryNormal, tEnvMap, uEnvMapIntensity, uEnvMapRotation);


/// #replace #define SIXTY_END_AREA
gl_FragColor.rgb = mix(gl_FragColor.rgb, gl_FragColor.rgb * .4, uDarkMode);`;

                            function replace(chunksCode = '', defaultShader = '') {
                                const chunks = parseCode(chunksCode);
                                chunks.forEach(({ target, replace }) => {
                                    defaultShader = defaultShader.replace(target, replace);
                                });

                                return defaultShader;
                            }

                            function parseCode(code, pattern = '/// #replace') {
                                const replacements = [];
                                const lines = code.trim().split('\n');

                                for (let i = 0; i < lines.length; i++) {
                                    const line = lines[i].trim();
                                    if (line.startsWith(pattern)) {
                                        const target = line.replace(pattern, '');
                                        const replaceLines = [];
                                        let j = i + 1;

                                        while (j < lines.length && !lines[j].trim().startsWith(pattern)) {
                                            const nextLine = lines[j].trim();
                                            if (nextLine) {
                                                replaceLines.push(nextLine);
                                            }
                                            j++;
                                        }

                                        const replace = replaceLines.join('\n');
                                        replacements.push({ target: target.trim(), replace: replace.trim() });

                                        i = j - 1;
                                    }
                                }
                                return replacements;
                            }

                            export default {
                                use: (el) => {
                                    const instance = el.material || el;
                                    instance['fragmentShader'] = replace(chunks, instance['fragmentShader']);
                                    instance.needsUpdate = true;
                                    return el;
                                }
                            }
                        